<template>
  <div class="ai-resume-container">
    <pc-navbar />
    <div class="bg-cover">
      <div v-for="i in 2" :key="i" class="bg-cover-item">
        <img
          :src="
            i % 2 === 0
              ? 'https://logo.wondercv.com/banners/H4ebMnb4QfkUvAy.png'
              : 'https://logo.wondercv.com/banners/Fcg3vGErlTt8rHN.png'
          "
          alt=""
        />
      </div>
    </div>
    <div class="talking-container">
      <transition-group name="el-fade-in-linear">
        <div v-if="stepEnum === 'init'" key="init">
          <MessageItem
            class="talking-item"
            type="text"
            content="你好！我是超级简历WonderCV AI 助手，仅需回答几个问题即可生成专属简历。"
            :marginTop="0"
          />
          <IdentityPicker
            v-if="displayIdentiryPicekr"
            :gender="payload.gender"
            :identity="payload.status"
            @confirm="confirm"
          />
          <transition name="el-fade-in-linear">
            <MessageItem
              v-if="resumeVisible"
              class="talking-item"
              title="请问你是否已有简历？"
              type="singlePicker"
              payload-key="resume"
              :displayAvatar="false"
              :marginTop="16"
              :active-value="payload.resume"
              :options="RESUME_OPTIONS"
              @confirm="confirm"
            />
          </transition>
        </div>
        <ResumeCreatePicker
          v-if="payload.resume && stepEnum === 'init'"
          key="resume"
          :resume="payload.resume"
          @clickItem="clickResumeCreateItem"
        />
        <ImportResume
          v-show="stepEnum === 'import'"
          key="import"
          @beforeCreateResume="beforeCreateResume"
          @nextStep="nextStep"
          @prevStep="prevStep"
          @resumeChange="onSuccess"
        />
        <Progress
          v-if="stepEnum === 'progress'"
          key="progress"
          :percentage="percentage"
          :fileImage="fileImage"
          :fileName="fileName"
          @nextStep="nextStep"
        />
        <ResumePicker
          v-if="stepEnum === 'resume'"
          key="resumePicker"
          :professionList="professions"
          @prev="prevStep"
          @buyMember="payAlertVisible = true"
          @changeCreateResumeLoading="changeCreateResumeLoading"
        />
        <AiResumeProgress
          v-if="(processType === 'ai' && step > 0) || inAiProgress"
          :percentage="aiResumeProgressPercentage"
          key="aiResumeProgress"
        />
        <div v-if="stepEnum === 'experience'" class="flex flex-col" key="experience">
          <MessageItem
            class="resume-progress-item"
            title="请选择就业年限"
            type="singlePicker"
            payload-key="work_years"
            required
            :displayAvatar="false"
            :marginTop="16"
            :active-value="payload.work_years"
            :options="WORK_YEARS_OPTIONS"
            @confirm="confirm"
          />
          <ProgressBtnGroup :disabled="!payload.work_years" @prev="prevStep" @next="nextStep" />
        </div>
        <div v-if="stepEnum === 'profession'" class="flex flex-col" key="profession">
          <MessageItem
            class="resume-progress-item"
            title="请选择你期望的职位"
            required
            type="multiLevelPicker"
            payload-key="profession"
            placeholder="请选择职业方向"
            :active-value="payload.profession"
            :select-options="professions"
            @confirm="confirm"
          />
          <ProgressBtnGroup :disabled="!payload.profession" @prev="prevStep" @next="nextStep" />
        </div>
        <div v-if="stepEnum === 'industry'" class="flex flex-col" key="industry">
          <MessageItem
            class="resume-progress-item"
            title="请选择你的行业类型"
            required
            type="singlePickerSelect"
            payload-key="industry"
            :active-value="payload.industry"
            :select-options="industries"
            :options="INDUSTRIES_OPTIONS"
            placeholder="请选择行业类型"
            @confirm="confirm"
          />
          <ProgressBtnGroup :disabled="!payload.industry" @prev="prevStep" @next="nextStep" />
        </div>
        <div v-if="stepEnum === 'university'" class="flex flex-col" key="university">
          <EducationalPicker
            :form="educationalForm"
            :identity="payload.status"
            @educationChange="educationChange"
          />
          <ProgressBtnGroup :disabled="educationalDisabled" @prev="prevStep" @next="nextStep" />
        </div>
        <div v-if="stepEnum === 'skills'" class="flex flex-col" key="skills">
          <MessageItem
            class="resume-progress-item"
            title="请选择下方最符合你的软技能（可多选）："
            type="multiPicker"
            payload-key="soft_skills"
            :active-value="payload.soft_skills"
            :options="softSkillsOptions"
            hidden-confirm-btn
            @confirm="confirm"
          />
          <ProgressBtnGroup @prev="prevStep" @next="nextStep" />
        </div>
        <div v-if="stepEnum === 'certificate'" class="flex flex-col" key="certificate">
          <MessageItem
            class="resume-progress-item"
            title="请填写你获得过的资格证书（可多选）:"
            type="multiPickerInput"
            payload-key="certificate"
            input-type="enter"
            placeholder="请输入完成，回车添加"
            :active-value="payload.certificate"
            :options="CERTIFICATE_OPTIONS"
            hidden-confirm-btn
            @confirm="confirm"
          />
          <ProgressBtnGroup @prev="prevStep" @next="nextStep" />
        </div>
        <div v-if="stepEnum === 'organization'" class="flex flex-col" key="honor">
          <MessageItem
            class="resume-progress-item"
            title="请问你曾参与过哪些校园活动（可多选）"
            type="multiPickerInput"
            payload-key="orgs"
            input-type="enter"
            placeholder="请输入完成，回车添加"
            :active-value="payload.orgs"
            :options="ORGS_OPTIONS"
            hidden-confirm-btn
            @confirm="confirm"
          />
          <ProgressBtnGroup @prev="prevStep" @next="nextStep" />
        </div>
        <div v-if="stepEnum === 'honor'" class="flex flex-col" key="honor">
          <MessageItem
            class="resume-progress-item"
            title="请问你曾获得过哪些荣誉奖项（可多选）"
            type="multiPickerInput"
            payload-key="honors"
            input-type="enter"
            placeholder="请输入完成，回车添加"
            :active-value="payload.honors"
            :options="HONOR_OPTIONS"
            hidden-confirm-btn
            @confirm="confirm"
          />
          <ProgressBtnGroup @prev="prevStep" @next="nextStep" />
        </div>
        <div v-if="stepEnum === 'profile'" class="flex flex-col" key="profile">
          <OnboardingProfile ref="onboardingProfileRef" :form="payload" @confirm="confirm" />
          <ProgressBtnGroup right-text="生成简历" @prev="prevStep" @next="saveProfile" />
        </div>
      </transition-group>
    </div>
    <div v-if="createResumeLoading" class="create-resume-loading">
      <img src="https://logo.wondercv.com/banners/rAghYlVaIKQSdfY.gif" alt="" />
    </div>
    <StayModal :visible="stayVisible" @close="changeStayVisible(false)" />
    <NoCountModal v-if="noCountModalVisible" @more="handleMore" @know="handleKnow" />
    <PayAlert v-if="payAlertVisible" @close="payAlertVisible = false" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import api from '@/api/index';
import PcNavbar from '@/components/base/navbar';
import MessageItem from './components/MessageItem.vue';
import ResumeCreatePicker from './components/ResumeCreatePicker.vue';
import ResumePicker from './components/ResumePicker.vue';
import ImportResume from './components/ImportResume.vue';
import Progress from './components/Progress.vue';
import IdentityPicker from './components/IdentityPicker.vue';
import AiResumeProgress from './components/AiResumeProgress.vue';
import EducationalPicker from './components/EducationalPicker.vue';
import OnboardingProfile from './components/OnboardingProfile.vue';
import ProgressBtnGroup from './components/ProgressBtnGroup.vue';
import MultiLevelPicker from './components/MultiLevelPicker.vue';
import NoCountModal from './components/NoCountModal.vue';
import StayModal from './components/StayModal.vue';
import PayAlert from '../account/user/payAlert.vue';
import { get_tUser, routerTo } from '@/assets/js/util';
import { toLogin } from '@/assets/js/jwt';
import { resumeMixin, breakResumeMixin } from './resume.mixin';

import {
  RESUME_OPTIONS,
  INDUSTRIES_OPTIONS,
  SKILLS_OPTIONS,
  CERTIFICATE_OPTIONS,
  LOCAL_STEPS,
  BASED_STEPS,
  AI_STEPS_STUDENT,
  AI_STEPS_WORKER,
  TEMPLATE_STEPS,
  WORK_YEARS_OPTIONS,
  ORGS_OPTIONS,
  HONOR_OPTIONS,
  STUDENT_SKILLS_OPTIONS,
} from './const';

export default {
  name: 'AiOnboarding',
  mixins: [resumeMixin, breakResumeMixin],
  components: {
    PcNavbar,
    MessageItem,
    ResumeCreatePicker,
    ResumePicker,
    ImportResume,
    Progress,
    NoCountModal,
    PayAlert,
    IdentityPicker,
    AiResumeProgress,
    EducationalPicker,
    ProgressBtnGroup,
    MultiLevelPicker,
    OnboardingProfile,
    StayModal,
  },
  data() {
    return {
      processType: '',
      payload: {
        resume: '',
        profession: '',
        gender: '',
        status: '',
        industry: '',
        username: '',
        phone: '',
        email: '',
      },
      educationalForm: {
        degree: '',
        edu_type: '',
        graduate_at: '',
        university: '',
        university_id: '',
        major: '',
        major_id: '',
      },
      RESUME_OPTIONS,
      WORK_YEARS_OPTIONS,
      INDUSTRIES_OPTIONS,
      SKILLS_OPTIONS,
      CERTIFICATE_OPTIONS,
      ORGS_OPTIONS,
      HONOR_OPTIONS,
      STUDENT_SKILLS_OPTIONS,
      professions: [],
      industries: [],
      step: 0,
      stepData: {},
      createResumeLoading: false,
      noCountModalVisible: false,
      payAlertVisible: false,
      inAiProgress: false,
      stayVisible: false,
    };
  },
  computed: {
    ...mapState('me', ['personInfo']),
    displayIdentiryPicekr() {
      if (this.personInfo) {
        const length = Object.keys(this.personInfo)?.length;
        return length > 2 && !this.personInfo.match;
      }
    },
    steps() {
      switch (this.processType) {
        case 'local':
          return LOCAL_STEPS;
        case 'based':
          return BASED_STEPS;
        case 'ai':
          return this.payload.status === 'student' ? AI_STEPS_STUDENT : AI_STEPS_WORKER;
        case 'template':
          return TEMPLATE_STEPS;
      }
    },
    stepEnum() {
      if (this.step === -1) return '';
      return this.steps?.[this.step] || 'init';
    },
    resumeVisible() {
      return (this.payload.gender && this.payload.status) || this.personInfo?.match;
    },
    aiResumeProgressPercentage() {
      const length = this.steps.length - 1;
      return (this.step / length) * 100;
    },
    softSkillsOptions() {
      return this.payload.status === 'student' ? STUDENT_SKILLS_OPTIONS : SKILLS_OPTIONS;
    },
    educationalDisabled() {
      const keys = ['degree', 'edu_type', 'graduate_at', 'university', 'major'];
      return keys.some((key) => !this.educationalForm[key]);
    },
  },
  watch: {
    step(newVal) {
      if (newVal === -1 || this.processType !== 'ai') return;
      if (newVal > 0) {
        this.inAiProgress = true;
      } else if (newVal === 0) {
        this.inAiProgress = false;
      }
    },
    personInfo(newVal) {
      if (newVal?.match) {
        this.payload.status = newVal.is_student ? 'student' : 'already_work';
      }
    },
  },
  methods: {
    nextStep() {
      const step = this.step;
      this.step = -1;
      const timer = setTimeout(() => {
        this.step = step + 1;
        clearTimeout(timer);
      }, 500);
    },
    prevStep() {
      const step = this.step;
      if (this.step === 1) {
        this.inAiProgress = false;
      }
      this.step = -1;
      const timer = setTimeout(() => {
        this.step = step - 1;
        clearTimeout(timer);
      }, 500);
    },
    onSuccess(token) {
      this.resumeChange(token);
      const timer = setTimeout(() => {
        routerTo(`/ai/resume/${token}/preview`);
        clearTimeout(timer);
      }, 500);
    },
    changeStayVisible(value) {
      this.stayVisible = value;
    },
    changeCreateResumeLoading(value) {
      this.createResumeLoading = value;
    },
    saveProfile() {
      if (['username', 'phone', 'email'].some((key) => !this.payload[key]))
        return this.changeStayVisible(true);
      this.$refs.onboardingProfileRef.$refs?.formRef?.validate((valid) => {
        if (valid) {
          this.clickViewResult();
        } else {
          return false;
        }
      });
    },
    handleMore() {
      window.location.href = '/jianlimoban/';
    },
    handleKnow() {
      window.location.href = '/cvs';
    },
    confirm(item, key) {
      const value = item instanceof Object ? item.value : item;
      this.payload[key] = value;
      this.$forceUpdate();
    },
    educationChange(value) {
      this.educationalForm = value;
    },
    checkStayModal(event) {
      if (this.stepEnum === 'profile') {
        event?.preventDefault();
        return 'stay';
      }
    },
    async clickResumeCreateItem(value) {
      if (!this.personInfo.match) {
        const state = await this.updateMatchInfo();
        if (state !== 'success') return;
      }

      this.processType = value;
      if (value === 'ai') {
        this.fetchAiResumeProfile();
        this.fetchAiResumeEdu();
      }
      switch (value) {
        case 'template':
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'template',
            isDarkTheme: true,
          });
          break;
        default:
          this.nextStep();
          break;
      }
    },
    async updateMatchInfo() {
      try {
        const accountToken = get_tUser().c_t;
        const [res1, res2] = await Promise.all([
          api.me.updateUserInfo(accountToken, {
            gender: this.payload.gender,
          }),
          api.identity.setIdentity({ status: this.payload.status }, accountToken),
        ]);
        if (res1.code === 1000 && res2.code === 1000) {
          return 'success';
        }
      } catch (error) {
        console.log(error);
      }
    },
    async clickViewResult() {
      try {
        const { resume, status, gender, ...rest } = this.payload;
        const params = {
          ...rest,
          ...this.educationalForm,
          identity: status === 'student' ? '学生' : '职场人',
        };
        for (const key in params) {
          if (params[key] === 'skip') {
            params[key] = '';
          }
        }
        window.removeEventListener('beforeunload', this.checkStayModal);
        this.createResumeLoading = true;
        const res = await api.AI.createAiResume(params);
        if (res.code === 1000) {
          routerTo(`/ai/resume/${res.data.cv_token}/preview`);
        } else {
          switch (res.code) {
            case 3001:
              this.payAlertVisible = true;
              this.$message.error(res.message);
              break;
            case 3000:
              this.memberResumeLimit(res);
              break;
            case 3003:
              this.noCountModalVisible = true;
              this.$message.error(res.message);
              break;
            default:
              this.$message.error(res.message);
              break;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.createResumeLoading = false;
      }
    },
    async getIndustryList() {
      try {
        const res = await api.recruit.get_industries_list();
        if (res.code === 1000) {
          this.industries = res.data.map((item) => ({
            ...item,
            title: item.cn,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getProfessions() {
      try {
        const res = await api.staticApi.getProfessionsTree();
        if (res.code === 1000) {
          this.professions = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAiResumeProfile() {
      try {
        const accountToken = get_tUser().c_t;
        const res = await api.AI.getAiResumeProfile(accountToken);
        if (res.code === 1000) {
          const { username, phone, email } = res.data;
          this.payload.username = username;
          this.payload.phone = phone;
          this.payload.email = email;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAiResumeEdu() {
      try {
        const accountToken = get_tUser().c_t;
        const res = await api.AI.getAiResumeEdu(accountToken);
        if (res.code === 1000) {
          const { degree, edu_type, grduate_at, uni_name, major } = res.data;
          this.educationalForm.degree = degree;
          this.educationalForm.edu_type = edu_type;
          this.educationalForm.graduate_at = grduate_at || '';
          this.educationalForm.university = uni_name;
          this.educationalForm.major = major;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeCreate() {
    if (!get_tUser().c_t) {
      toLogin({ login: true });
    }
  },
  created() {
    this.getIndustryList();
    this.getProfessions();
    this.$store.dispatch('cv/getCvsList');
    window.addEventListener('beforeunload', this.checkStayModal);
    this.payload.resume = this.$route.query.resume || '';
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.checkStayModal);
  },
};
</script>
<style lang="scss" scoped>
.ai-resume-container {
  position: relative;
  min-height: 100vh;
  background-color: #191c20;
  overflow: hidden;
  padding-top: 153px;
  box-sizing: border-box;
  padding-bottom: 300px;
  .bg-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 1000vh;
    padding-top: 256px;
    .bg-cover-item {
      width: 100%;
      &:nth-child(2n) {
        display: flex;
        justify-content: flex-end;
      }
      img {
        width: 246px;
        height: 369px;
        object-fit: contain;
      }
    }
  }
  .talking-container {
    position: relative;
    z-index: 1;
    width: fit-content;
    margin: 0 auto;
    .talking-item {
      :deep(.content) {
        width: 580px;
        .picker-container {
          .picker-item {
            flex: 1;
          }
        }
      }
    }
    .resume-progress-item {
      padding-right: 0;
      width: fit-content;
      :deep(.content) {
        width: 622px;
        .multi-level-picker {
          .multi-level-content {
            width: 100%;
          }
        }
      }
    }
    .onboarding-block-wrapper {
      .onboarding-block-container {
        padding: 20px;
        background: linear-gradient(79deg, #272b33 65%, #523433 100%);
        border-radius: 0 12px 12px 12px;
      }
    }
  }
  .create-resume-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 29;
    img {
      width: 200px;
      height: 200px;
    }
  }
}
</style>
<style lang="scss">
.onboarding-robot {
  #udesk_btn .udesk-client-btn::before {
    color: #fff;
  }
}
</style>
